import $ from 'jquery';
import BetslipController from '../BetslipController';
import i18n from '../../../../../shared/utils/i18n';
import formatCurrency from '~shared/utils/currencyUtils';
import { pushToDataLayer } from '~shared/utils/google-tag-manager.js';
import {
    GTM_BETSLIP,
    GTM_STAKE_AREA_EVENT,
    GTM_STAKE_AREA,
    GTM_EVENT_FREE_BET
} from '~legacy/modules/jsx/betslip/constants.js';

const FreebetModule = {

    /**
     * FREEBET MODULE
     */

    //shows the freebet module if it is not visible
    fkFreebetShowModule: function (freeBets, usedFreeBets, elem = {}, rerenderFreebetsModule = false) {

        if (!this.freeBetModuleVisible || rerenderFreebetsModule) {
            this.freebetModule.find('.freebetVoucher').remove();

            let showFreebetModule = false;
            let usedBet = 0;
            // eslint-disable-next-line guard-for-in
            for (const fb in freeBets) {
                const freeBet = freeBets[fb];
                let alreadyTaken = false;

                if (usedFreeBets.indexOf(freeBet.id) > -1) {
                    alreadyTaken = true;
                    usedBet++;
                }
                if (usedBet === freeBets.length) {
                    showFreebetModule = false;
                    continue;
                }

                this.fkFreebetDisplay(freeBet.id, freeBet.value, alreadyTaken);
                if (elem.length > 0) {
                    if (elem.hasClass('selection-stake-details__stake-holder')) {
                        showFreebetModule = !$.isEmptyObject(freeBets);
                    } else if (elem.hasClass('betslip-multiples__bet-type__stake')){
                        showFreebetModule = !$.isEmptyObject(freeBets) &&
                            this.boundToElement.data('freebetAvailable');
                    }
                }

                continue;
            }

            if (showFreebetModule) {
                this.freebetModule.css('display', 'inline-block').animate({"top": "0"}, this.animationSpeed);
                this.freeBetModuleVisible = true;
            }
        }
    },

    //hides the freebet module if it is visible
    fkFreebetHideModule: function (cb) {
        var self = this;
        if (this.freeBetModuleVisible) {
            this.freebetModule.animate({"top": "-52px"}, this.animationSpeed, function () {
                self.freebetModule.css('display', 'none');
                cb();
            });
            this.freeBetModuleVisible = false;
        }
    },

    /**
     * draws and display the specified freebet voucher
     * @param  {integer} freebetID    unique id of the freebet
     * @param  {Float} freebetValue freebet stake value
     * @param  {Boolean} alreadyTaken Whether the freebet has already been taken
     * @return {void}
     */
    fkFreebetDisplay: function (freebetID, freebetValue, alreadyTaken) {
        const freebetVoucher = this.fkFreebetCreateVoucher(freebetID, freebetValue, alreadyTaken);
        freebetVoucher.insertAfter(this.freebetModule.find('label'));
    },

    /**
     * Creates a freebet voucher DOM structure
     * @param  {integer} freebetID    unique id of the freebet
     * @param  {Float} freebetValue freebet stake value
     * @param  {Boolean} alreadyTaken Whether the freebet has already been taken
     * @return {jQuery} freebet voucher
     */
    fkFreebetCreateVoucher: function (freebetID, freebetValue, alreadyTaken) {
        const freebetVoucher = $("<div class='freebetVoucher "
            + (alreadyTaken
                ? 'alreadyTaken'
                : '')
            + "' data-freebet-value='"
            + freebetValue
            + "' data-freebet-id='"
            + freebetID + "'>"
            + "<p class='freebet--under'>" + i18n.t('betslip.free_bet') + "</p>"
            + "<p class='freebet--title'>" + formatCurrency(freebetValue, null, null, true, true, 2) + "</p>"            
            + "</div>");
        return freebetVoucher;
    },

    /**
     * user select a freebet
     * @param  {Jquery Object} freebetVoucher freebetVoucher
     */
    fkFreebetSelected: function (freebetVoucher) {
        var freebetId;
        //if the selected freebet isn't alreadyTaken
        if (!freebetVoucher.hasClass('alreadyTaken')) {
            freebetId = freebetVoucher.data('freebetId');
            var freebetValue = parseFloat(freebetVoucher.data('freebet-value')).toFixed(2);
            var oldVoucherId = null;
            freebetVoucher.attr('id', 'selectedVoucher-' + freebetId);

            //if the user has already chosen a freebet
            if (this.stakeLabel.data('hasFreebet')) {
                var oldVoucher = this.stakeLabel.closest('.selection-stake-details__stake-row, .betslip-multiples__bet-type__stake-details').find('.freebetVoucher');
                oldVoucherId = oldVoucher.data('freebetId');
                oldVoucher.remove();
            }

            this.stakeLabel.data('freebetId', freebetId).attr('data-freebet-id', freebetId);
            this.stakeLabel.data('value', freebetValue).attr('data-value', freebetValue);
            this.stakeLabel.data('hasFreebet', true);
            this.fkFreebetReplaceStakeField(freebetVoucher, oldVoucherId, this.stakeLabel);
            this.stakeLabel.data('value', freebetValue).trigger('stakeValueChanged');

            //adds GTM when free bet is selected
            pushToDataLayer({
                event: GTM_STAKE_AREA_EVENT, 
                parameter: `${GTM_BETSLIP};${GTM_STAKE_AREA};${GTM_EVENT_FREE_BET}-${freebetValue}`,
                ecommerce: undefined,
            });
        }
    },

    /**
     * deselect the specified freebet voucher
     * @param  {Object} freebetVoucher the freebet voucher to deselect
     * @return {void}
     */
    fkFreebetDeselectVoucher: function (freebetVoucher) {
        const freebetId = freebetVoucher.data('freebetId');
        const selectedStakeLabel = freebetVoucher.closest('.selection-stake-details__stake-row, .betslip-multiples__bet-type__stake-details').find('label.fancyKeyboard-bindable');
        const stakeLabelContainer = selectedStakeLabel.closest('.stake-selection-container');
        const isMultiple = selectedStakeLabel.hasClass('betslip-multiples__bet-type__stake');

        selectedStakeLabel.data('freebetId', '').attr('data-freebet-id', '');
        selectedStakeLabel.data('value', 0).attr('data-value', '0');
        selectedStakeLabel.data('hasFreebet', false);
        freebetVoucher.remove();

        selectedStakeLabel.show();
        stakeLabelContainer.removeClass(isMultiple ? 'betslip-multiples__bet-type__stake-details--stake-container_free-bet--active' : 'selection-stake-details__stake-row--stake-container_free-bet--active');
        if (this.isVisible) {
            this.fkDisappear();
        }
        BetslipController.getSelectionFreeBets(selectedStakeLabel);
        $(`#selectedVoucher-${freebetId}`).removeClass('alreadyTaken');
        selectedStakeLabel.trigger('stakeValueChanged');
    },

    /**
     * replaces the stakelabel with a freebetVoucher
     * @param  {Jquery Object}                      freebetVoucher
     * @param  {Jquery Object | null}               previouslySelectedVoucher
     * @param  {Jquery Object} stakeLabel           selected element stakelabel
     */
    fkFreebetReplaceStakeField: function (freebetVoucher, previouslySelectedVoucherId, stakeLabel) {
        if (previouslySelectedVoucherId !== null) {
            $('#selectedVoucher-' + previouslySelectedVoucherId).removeClass('alreadyTaken');
        }

        var freebetVoucherOffset = freebetVoucher.offset();
        var stakeLabelOffset = stakeLabel.offset();
        var offVoucher = freebetVoucher.clone();
        const stakeLabelContainer = stakeLabel.closest('.stake-selection-container');
        const isMultiple = stakeLabel.hasClass('betslip-multiples__bet-type__stake');
        var self = this;
        offVoucher.addClass('offVoucher')
                .detach();

        freebetVoucher.addClass('alreadyTaken');
        stakeLabel.hide();
        stakeLabelContainer.addClass(isMultiple ? 'betslip-multiples__bet-type__stake-details--stake-container_free-bet--active' : 'selection-stake-details__stake-row--stake-container_free-bet--active');
        offVoucher.insertAfter(stakeLabel);

        if ((freebetVoucherOffset.top > 0 && stakeLabelOffset.top > 0) && freebetVoucherOffset.left > 0 && stakeLabelOffset.left > 0) {
            offVoucher.css({'top': (freebetVoucherOffset.top - stakeLabelOffset.top) + 'px', 'left': (freebetVoucherOffset.left - stakeLabelOffset.left) + 'px'})
                    .animate({"top": "0px", 'left': '8px'}, self.animationSpeed, function () {
                        self.fkHide(function () {
                            self.fkUnbindKeyboard();
                        });
                    });
        }

        stakeLabel.trigger('stakeValueChanged');
    }
};

export default FreebetModule;
